
import { Product } from "@/types/product";

export const ipxTX3AWP2C: Product = {
  id: "ipx-tx3a-wp-2-c",
  groupId: "avoip",
  name: "IPX-TX3A-WP-2-C",
  subtitle: "10Gb Wall Plate Transceiver",
  description: "The IPX-TX3A-WP-2-C is a sophisticated 10G AV over IP wall plate transmitter that combines high performance with installation convenience. This dual-input wall plate solution supports full 4K60 4:4:4 video with zero compression and zero latency, making it perfect for high-end presentation spaces and collaborative environments.\n\nFeaturing auto-switching capability between its dual HDMI 2.0 inputs, the wall plate transmitter is powered via PoE for simple installation. Built on SDVoE Technology, it delivers pristine video quality while offering comprehensive control options through RS-232, web GUI, and API interfaces.\n\nThe IPX-TX3A-WP-2-C is the ideal solution for premium meeting spaces, lecture halls, and executive boardrooms where both performance and aesthetics are critical requirements.",
  features: [
    "4K60 4:4:4 Over 10G Copper",
    "1.3:1 Lossless Compression and Zero Frame Latency (100us) for 4K60 4:4:4",
    "Zero Compression/Frame Latency (22us) for 4K60 4:2:0 and below",
    "Secure Content Encryption",
    "128x128 Capable with HDCP, Larger for Non-Encrypted Sources",
    "Seamless Switching including local inputs & Break-away Switching",
    "10/100/1000Mbps LAN PoE (PD)",
    "RS-232 Serial Port",
    "USB 1.1 (HID) or USB 2.0 480Mbps IP Extension",
    "Dante®/AES67 IP 2Ch and 8Ch Audio (Optional)",
    "Auto Sense Switching"
  ],
  specifications: [
    "Resolution: 4K60 4:4:4",
    "Compression: Zero (4K30 4:4:4/4K60 4:2:0), 1.3:1(4K60 4:4:4)",
    "Latency: Zero Frame Latency (100us without Scaling, 3ms with Scaling)",
    "HDMI Inputs: Two HDMI 2.0 with HDCP 2.2",
    "10G Copper Ethernet: RJ-45 330ft(100m) with CAT 6A PoE",
    "Video Bandwidth: 600MHz",
    "Video support: Up to 4K2K 4:4:4 @60Hz",
    "USB Function: USB 1.1 Standard 10Mbps or USB 2.0 480Mbps",
    "Expansion Ports: ExtermeUSB® & Dante®",
    "Housing: 2 Gang Decora White or Black",
    "Dimensions [L x W x H]: 3.728\" x 2.83\" x 1.404\" (2 Gang)",
    "Mounting: Wall Box or Low Voltage Electrical Rings to fit Dim Above",
    "Power supply: PoE 10G LAN port or 48V DC",
    "Max Power consumption: 12.9 Watts",
    "Operation temperature: 0~40°C [32~100°F]",
    "Storage temperature: -20~60°C [-4~140°F]",
    "Relative humidity: 20~90% RH [no condensation]"
  ],
  images: [
    "/lovable-uploads/5410c110-a5ac-4b01-b423-5d1b4722b121.png"
  ],
  videoUrl: "https://youtu.be/T_GmvE3ExoE?si=4mNv77MwcggNB8sA",
  slug: "ipx-tx3a-wp-2-c",
  networkSpeed: "10gb"
};
